export default __webpack_public_path__ + "static/media/ruppes.a9928a5d.svg";